// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container {
  font-family: Ubuntu;
  position: fixed;
  left: 0; top: 0;
  width: 100%; height: 100%;
  pointer-events: fill;
  background: rgba(0.1,0.1,0.1,0.3);
  z-index: 9999;
}
.ble-button {
  font-size: 12px;
}
.image-container {
  margin: 10px 20px;
}
.content {
  border-radius: 10px;
  width: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  background: white;
  box-shadow: 0 0 10px #6c6c6c;
  border: 1px solid lightgray;
  padding: 10px;
  transform: translate(-50%, -50%);
} 
.help-text {
  white-space: pre-line;
  line-height: 24px;
  font-size: 14px;
  font-family: 'Ubuntu';
  letter-spacing: 0.44px;
  margin-left: 10px;
}
.title {
  margin: 10px 10px;
  font-weight: bold;
  letter-spacing: 1.5px;
  text-align: center;
}
.device-title {
  text-align: center;
  font-weight: bold;
  letter-spacing: 1.5px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.device-subtitle {
  text-align: center;
  font-size: 13px;
  letter-spacing: 1.5px;
}
.device-status {
  margin: 5px 0;
  font-size: 14px;
}
.device-content {
  margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/super-pro/super-pro-page.ts"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,eAAe;EACf,OAAO,EAAE,MAAM;EACf,WAAW,EAAE,YAAY;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd","sourcesContent":["\n.container {\n  font-family: Ubuntu;\n  position: fixed;\n  left: 0; top: 0;\n  width: 100%; height: 100%;\n  pointer-events: fill;\n  background: rgba(0.1,0.1,0.1,0.3);\n  z-index: 9999;\n}\n.ble-button {\n  font-size: 12px;\n}\n.image-container {\n  margin: 10px 20px;\n}\n.content {\n  border-radius: 10px;\n  width: 90%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: white;\n  box-shadow: 0 0 10px #6c6c6c;\n  border: 1px solid lightgray;\n  padding: 10px;\n  transform: translate(-50%, -50%);\n} \n.help-text {\n  white-space: pre-line;\n  line-height: 24px;\n  font-size: 14px;\n  font-family: 'Ubuntu';\n  letter-spacing: 0.44px;\n  margin-left: 10px;\n}\n.title {\n  margin: 10px 10px;\n  font-weight: bold;\n  letter-spacing: 1.5px;\n  text-align: center;\n}\n.device-title {\n  text-align: center;\n  font-weight: bold;\n  letter-spacing: 1.5px;\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.device-subtitle {\n  text-align: center;\n  font-size: 13px;\n  letter-spacing: 1.5px;\n}\n.device-status {\n  margin: 5px 0;\n  font-size: 14px;\n}\n.device-content {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
